<template>
  <div class="row d-flex justify-content-between confidential__cont">
    <div class="col-xs-12 col-md-6 col-lg-6 text-left">
      <p class="mb-0">*Última fecha de actualización: {{ today }}</p>
      <p v-if="showLastUpdate && !lastUpdateNotAllowed()">
        ** Última actualización de Estructura comercial:
        {{ lastUpdate.date }}
      </p>
    </div>
    <div class="col-xs-12 col-md-6 col-lg-6">
      <p class="text-right text-conf">
        Información confidencial Prohibida su reproducción o divulgación total o
        parcial, así como su uso o aprovechamiento sin autorización escrita de
        IUSA.
      </p>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import { dateFormatWithAmPmDots } from '@/utilities/date-formater';
  import { mapGetters } from 'vuex';
  import axios from '@/plugins/axios';

  export default {
    data() {
      return {
        today: dateFormatWithAmPmDots(moment(), true),
        lastUpdate: {
          date: '',
          loading: false,
          errorMsg: '',
          disabledOnRoles: ['Customer', 'CustomerPR'],
        },
      };
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
      }),
      showLastUpdate() {
        return (
          this.lastUpdate.date !== '' &&
          this.lastUpdate.errorMsg === '' &&
          !this.lastUpdate.loading
        );
      },
    },
    mounted() {
      if (!this.lastUpdateNotAllowed()) {
        this.getLastUpdate();
      }
    },
    methods: {
      lastUpdateNotAllowed() {
        return this.$hasAnyRole(this.lastUpdate.disabledOnRoles);
      },
      async getLastUpdate() {
        this.lastUpdate.loading = true;
        try {
          const response = await axios.get('project-manager/last-update');
          this.lastUpdate.date = response.data.FEACT;
        } catch (error) {
          this.lastUpdate.errorMsg =
            'Error al obtener la última actualización de ECOM';
        } finally {
          this.lastUpdate.loading = false;
        }
      },
    },
  };
</script>

<style scoped>
  .confidential__cont p {
    font-size: 14px;
  }

  .text-conf {
    color: #bdbdbd;
    text-align: right;
  }

  @media (max-width: 965px) {
    .confidential__cont p {
      text-align: center !important;
    }
  }
</style>
